import { render, staticRenderFns } from "./SPItem.vue?vue&type=template&id=b49b8d48"
import script from "./SPItem.vue?vue&type=script&lang=js"
export * from "./SPItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports